// extracted by css-extract-rspack-plugin
var _1 = "filter-xhCEtN";
var _2 = "table-NJp4X0";
export { _1 as "filter", _2 as "table" }
